export default __webpack_public_path__ + "static/font-c6196d60cf74b6131c80dba0304624d8.eot";